import axios from "axios";
import config from "../config";

const BASE_API = config.BASE_API;


const getReports = (params) => {
  return axios.get(BASE_API + "recadastramento/filter", {
    params
  });
};

const visualizarRelatorioCompleto = async (params) => {
  try {
      const response = await axios.get(`${BASE_API}relatorios/censo-feito`, {
          params,
          responseType: "blob"
      });

      return response.data;
  } catch (error) {
      console.error("Erro ao obter o relatório:", error);
      throw error; // Relança o erro para ser tratado no componente
  }
};

const downloadRelatorioCsvCenso = async (params) => {
  try {
    const response = await axios.get(`${BASE_API}relatorios/censo-feito-csv`, {
      params,responseType: "blob"
    });

    if (response && response.data) {
      const blob = response.data;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "relatorio_censo.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Erro ao obter dados para o CSV.");
    }
  } catch (error) {
    console.error("Erro ao gerar CSV:", error);
  }
};

const downloadRelatorioBloqueioPorPeriodo = async (params) => {
  try {
    const response = await axios.get(`${BASE_API}relatorios/bloqueados-por-periodo`, {
      params: params,
      responseType: "blob",
    });

    const contentType = response.headers?.['content-type'] || '';

    const isJson = contentType.includes('application/json');
    if (isJson) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      const message = json.message || 'Erro desconhecido ao gerar o arquivo.';
      throw new Error(message);
    }

    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const formattedDate = `${day}_${month}_${year}`;

    const fileExtension = params.tipo === 'pdf' ? 'pdf' : 'csv';
    const fileName = `segurados_bloqueados_por_periodo_${formattedDate}.${fileExtension}`;

    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Erro ao fazer download:", error);

    // Aqui tratamos erros vindos de uma falha de rede ou do axios
    if (error.response && error.response.data) {
      try {
        const blob = error.response.data;
        const text = await blob.text();
        const json = JSON.parse(text);
        const message = json.message || "Erro desconhecido.";
        alert(message);
      } catch {
        alert("Erro ao interpretar a resposta de erro.");
      }
    } else {
      alert(error.message || "Erro ao gerar o arquivo.");
    }
  }
};





export default {
  getReports,visualizarRelatorioCompleto,downloadRelatorioCsvCenso,downloadRelatorioBloqueioPorPeriodo
};
